import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Admin, isAdmin, setAdminPin, clearAdminPin } from "@/lib/api";
import { toast } from "sonner";
import { LockKey, SignOut } from "@phosphor-icons/react";

export default function AdminGate() {
    const nav = useNavigate();
    const [pin, setPin] = useState("");
    const [loading, setLoading] = useState(false);

    if (isAdmin()) {
        return (
            <div className="max-w-md mx-auto" data-testid="admin-signed-in">
                <Card className="card-lux">
                    <CardContent className="p-8 text-center space-y-4">
                        <LockKey weight="fill" size={44} className="text-gold mx-auto" />
                        <h2 className="font-serif text-3xl">Signed in as admin</h2>
                        <p className="text-muted-foreground text-sm">
                            You have access to Reception, Tables, Dealer and Players.
                        </p>
                        <div className="flex gap-2 justify-center">
                            <Button data-testid="btn-goto-reception" onClick={() => nav("/reception")} className="btn-gold">Open Reception</Button>
                            <Button
                                data-testid="btn-sign-out"
                                variant="outline"
                                onClick={() => { clearAdminPin(); toast.success("Signed out"); nav("/checkin"); }}
                            >
                                <SignOut size={16} className="mr-1.5" /> Sign out
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </div>
        );
    }

    const submit = async (e) => {
        e?.preventDefault?.();
        if (!pin) { toast.error("Enter your PIN"); return; }
        setLoading(true);
        try {
            await Admin.login(pin);
            setAdminPin(pin);
            toast.success("Welcome back");
            nav("/reception");
        } catch (err) {
            toast.error("Invalid PIN");
        } finally { setLoading(false); }
    };

    return (
        <div className="max-w-md mx-auto" data-testid="admin-gate">
            <Card className="card-lux">
                <CardContent className="p-8 space-y-5">
                    <div className="text-center">
                        <LockKey weight="fill" size={44} className="text-gold mx-auto mb-2" />
                        <h2 className="font-serif text-3xl">Staff sign-in</h2>
                        <p className="text-muted-foreground text-sm mt-1">Enter your PIN to access the control panels.</p>
                    </div>
                    <form onSubmit={submit} className="space-y-3">
                        <div>
                            <Label className="label-mini">Admin PIN</Label>
                            <Input
                                data-testid="admin-pin-input"
                                type="password"
                                value={pin}
                                onChange={(e) => setPin(e.target.value)}
                                autoFocus
                                placeholder="••••"
                            />
                        </div>
                        <Button data-testid="admin-submit" type="submit" disabled={loading} className="btn-gold w-full h-11">
                            {loading ? "Signing in…" : "Sign in"}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}

export const AdminRoute = ({ children }) => {
    if (!isAdmin()) return <Navigate to="/admin" replace />;
    return children;
};
